<template>
  <div class="icon" :class="typeStyle" @click="$emit('click')"></div>
</template>

<script>
export default {
  props: ['types'],
  data() {
    return {};
  },
  computed: {
    typeStyle() {
      switch (+this.types) {
        case 2:
          return "type2";
        case 3:
          return "type3";
        default:
          return "type1";
      }
    },
  },
  methods: {},

  created() {},
};
</script>
<style lang="less" scoped>
.icon {
  width: 44px;
  height:44px;
  border-radius: 50%;
  background: #f2f4f9;

  overflow: hidden;
  position: relative;
  &::before {
    content: "+";
    display: inline-block;
    width: 44px;
    height: 44px;
    text-align: center;
    line-height: 40px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    color: #4275fd;
    font-size: 26px;
  }
  &.type1 {
    opacity: 0.4;
  }
  &.type2 {
    opacity: 1;
  }
  &.type3 {
    opacity: 1;
    background: #4275fd;
    &::before {
      content: "...";
      line-height: 27px;
      color: #fff;
    }
  }
}
</style>
